import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { parse, print } from 'graphql';
import GraphiQL from 'graphiql';
import { Helmet } from "react-helmet";
import { isMobileOnly, isMobile } from 'react-device-detect';
import Schema from './schemaGraphql';

import Loading from '../../components/Loading';
import ArrowIntroAnimation from '../../components/ArrowIntroAnimation';
import TransitionBackground from '../../components/TransitionBackground';

import imageSrcs from '../../constants/boringImageSrcs';

import 'graphiql/graphiql.css';
import './styles.css';

const propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default class BoringWorld extends Component {
  constructor(props) {
    super(props);

    localStorage.removeItem('graphiql:docExplorerOpen');
    localStorage.removeItem('graphiql:historyPaneOpen');

    this.graphiql = createRef();
    this.timeoutLoading = null;
    this.timeoutTransition = null;

    this.state = {
      isLoading: true,
      goToAdventureWorld: false,
      startArrowIntroAnim: false,
      hideArrow: false,
    };
  }

  componentDidMount() {
    this.timeoutLoading = setTimeout(() => {
      let counterImgLoad = 0;

      // eslint-disable-next-line no-unused-vars
      for (const url of imageSrcs) {
        const img = new Image();

        // eslint-disable-next-line no-loop-func
        img.onload = () => {
          counterImgLoad += 1;

          if (counterImgLoad === imageSrcs.length) {
            this.boringWorldIntro();
          }
        };

        img.src = url;
      }
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutLoading);
    clearTimeout(this.timeoutTransition);

    localStorage.removeItem('graphiql:docExplorerOpen');
    localStorage.removeItem('graphiql:historyPaneOpen');
  }

  graphQLFetcher = () => {
    const { query } = this.graphiql.current.state;
    const url = '/.netlify/functions/graphql';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    }).then(response => response.json());
  }

  boringWorldIntro = () => {
    const topBar = document.getElementsByClassName('topBarWrap');
    const resultPan = document.getElementsByClassName('resultWrap');
    const queryPan = document.getElementsByClassName('queryWrap');

    if (topBar !== undefined
      && resultPan !== undefined
      && queryPan !== undefined) {
      if (isMobileOnly) {
        topBar[0].classList.add('mobile');
        resultPan[0].classList.add('mobile');
        queryPan[0].classList.add('mobile');
      }

      topBar[0].classList.add('load');
      resultPan[0].classList.add('load');
      queryPan[0].classList.add('load');

      this.timeoutArrowAnim = setTimeout(() => {
        this.handleArrowIntro();
      }, 5000);
    }

    this.stopLoading();
  }

  boringWorldLeaving = () => {
    const topBar = document.getElementsByClassName('topBarWrap');
    const resultPan = document.getElementsByClassName('resultWrap');
    const queryPan = document.getElementsByClassName('queryWrap');

    if (topBar !== undefined
      && resultPan !== undefined
      && queryPan !== undefined) {
      if (isMobileOnly) {
        topBar[0].classList.add('mobile');
        resultPan[0].classList.add('mobile');
        queryPan[0].classList.add('mobile');
      }

      topBar[0].classList.add('leave');
      resultPan[0].classList.add('leave');
      queryPan[0].classList.add('leave');
    }
  }

  stopLoading = () => this.setState({ isLoading: false });

  startLoading = () => this.setState({ isLoading: true });

  handleArrowIntro = () => {
    this.setState({ startArrowIntroAnim: true });
  }

  handleClickPrettifyButton = () => {
    const editor = this.graphiql.current.getQueryEditor();
    const currentText = editor.getValue();
    const prettyText = print(parse(currentText));

    editor.setValue(prettyText);
  }

  handleClickHistoryButton = () => {
    this.graphiql.current.handleToggleHistory();
  }

  handleClickAdventureButton = () => {
    const { history } = this.props;
    const historyPan = document.getElementsByClassName('historyPaneWrap');
    const docPan = document.getElementsByClassName('docExplorerWrap');

    if (docPan.length > 0) {
      document.querySelector('.doc-explorer-title-bar .docExplorerHide').click();
    }

    if (historyPan[0].style.display === 'block') {
      document.querySelector('.history-title-bar .docExplorerHide').click();
    }

    this.setState({ goToAdventureWorld: true, hideArrow: true }, () => {
      this.boringWorldLeaving();

      this.timeoutTransition = setTimeout(() => {
        history.push('/adventure');
      }, 2500);
    });
  }

  render() {
    const defaultQuery = `# Hello!
# Welcome to my résumé or resume, as you wish!
#
# Powered by GraphQL and React, with love.
#
# For starters, theres already a sample query down there, all you need to do is press PLAY.
# Also feel free to check out the Docs over there ----->
#
# Amazing right? ...not really, if you want a more exciting experience just press the RED BUTTON!!

{
  my {
    name
    age
    email
    location
    github
    linkedin
    employed
  }
  softSkills {
    skills
  }
  hardSkills {
    skillLevelRange
    frontend {
      skill
      level
    }
    backend {
      skill
      level
    }
    devops {
      skill
      level
    }
  }
  secondarySkills {
    skills
  }
  jobs {
    company
    location
    website
    role
    started
    finished
  }
}
`;
    const {
      isLoading, goToAdventureWorld, startArrowIntroAnim, hideArrow,
    } = this.state;

    return (
      <>
        {goToAdventureWorld ? (<TransitionBackground loading />) : null}
        <div style={{ width: '100vw', height: '100vh', backgroundColor: '#cdeefe' }}>
          { isLoading ? (
            <Loading />
          ) : null}
        </div>
        <div style={{
          display: 'flex', height: '100vh', position: 'absolute', top: '0', bottom: '0', right: '0', left: '0', zIndex: '1',
        }}
        >
          <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta name="description" content="Mickael Neves - Front-End Developer from Portugal with an interactive resume." />
            <meta name="twitter:site" content="@MickaelNvs" />
            <meta name="twitter:creator" content="@MickaelNvs" />
            <meta name="twitter:title" content="Mickael Neves - Front-End Developer" />
            <meta name="twitter:card" content="Front-End Developer" />
            <meta property="og:title" content="Mickael Neves - Front-End Developer" />
            <meta property="og:url" content="https://www.mikemneves.com/" />
            <meta property="og:type" content="website" />
            <meta property="og:description" content="Front-End Developer" />
            <title>Mickael Neves</title>
          </Helmet>
          {
            !isMobile && !hideArrow ? (<ArrowIntroAnimation startAnim={startArrowIntroAnim} />) : null
          }
          <GraphiQL
            ref={this.graphiql}
            fetcher={this.graphQLFetcher}
            editorTheme="material"
            schema={Schema}
            query={defaultQuery}
            docExplorerOpen={false}
          >
            <GraphiQL.Logo>
              <div className="mn-logo" />
            </GraphiQL.Logo>
            <GraphiQL.Toolbar>
              <GraphiQL.Button
                onClick={this.handleClickPrettifyButton}
                label="Prettify"
                title="Prettify Query (Shift-Ctrl-P)"
              />
              <GraphiQL.Button
                onClick={this.handleClickHistoryButton}
                label="History"
                title="Show History"
              />
              {!isMobileOnly ? (
                <div className="adventure-button-frame plastic">
                  <div
                    className="adventure-button plastic"
                    onClick={this.handleClickAdventureButton}
                    onKeyPress={() => this.handleClickAdventureButton}
                    tabIndex={-1}
                    aria-label="Adventure Button"
                    role="button"
                  />
                </div>
              ) : null}
            </GraphiQL.Toolbar>
          </GraphiQL>
          {isMobileOnly && !isLoading && !goToAdventureWorld ? (
            <div className={`mobile ${!isLoading ? 'load' : ''} adventure-button-frame plastic`}>
              <div
                className="adventure-button plastic"
                onClick={this.handleClickAdventureButton}
                onKeyPress={() => this.handleClickAdventureButton}
                tabIndex={-1}
                aria-label="Adventure Button"
                role="button"
              />
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

BoringWorld.propTypes = propTypes;
